import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Typography, Menu, MenuItem, Button, useMediaQuery } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { useTheme } from '@mui/system';

const NavBar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="sticky" sx={{ background: 'linear-gradient(45deg, #2980b9, #27ae60);',color: 'white'}} >
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
        Vantage Finserv
        </Typography>

        {isMobile ? (
          <>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleMenuOpen}
              aria-label="menu"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              sx={{
                '& .MuiPaper-root': {
                  backgroundColor: '#2980b9', // Set background color for the menu
                  color: '#fff',            // Set font color for the menu items
                },
              }}
            >
              <MenuItem  sx={{color: '#2980b9'}} onClick={handleMenuClose}>
                <a href="/" style={{ textDecoration: 'none' }}>Home</a>
              </MenuItem>
              <MenuItem   sx={{color: '#2980b9'}} onClick={handleMenuClose}>
                <a href="#about" style={{ textDecoration: 'none' }}>About</a>
              </MenuItem>
              <MenuItem  sx={{color: '#2980b9'}} onClick={handleMenuClose}>
                <a href="#services" style={{ textDecoration: 'none' }}>Services</a>
              </MenuItem>
              <MenuItem  sx={{color: '#2980b9'}} onClick={handleMenuClose}>
                <a href="#contact" style={{ textDecoration: 'none' }}>Contact</a>
              </MenuItem>
            </Menu>
          </>
        ) : (
          <>
            <Button color="inherit" href="/">Home</Button>
            <Button color="inherit" href="#about">About</Button>
            <Button color="inherit" href="#services">Services</Button>
            <Button color="inherit" href="#contact">Contact</Button>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
